import * as types from "../actions/types";

const initialState = {
  regions: [],
  loading: false
};

export default function regions(state = initialState, action) {
  switch (action.type) {
    case types.SET_REGIONS_DATA:
      return {
        ...state,
        regions: action.payload
      };
    
    case types.SET_REGIONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
  
    default:
      return state;
  }
}

